import React from "react";

/*eslint-disable */

declare const window: any;

interface FinanzasOportunidadesComponentProps {
  opportunities: any;
}

const FinanzasOportunidadesComponent: React.FC<
  FinanzasOportunidadesComponentProps
> = ({ opportunities }) => {

  const [isVisible, setIsVisible] = React.useState(false);
    const ref = React.useRef<HTMLDivElement | null>(null);
    React.useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else if (entry.boundingClientRect.top > 0) {
            setIsVisible(false);
          }
        },
        {
          threshold: 0.1,
        }
      );
  
      if (ref.current) {
        observer.observe(ref.current);
      }
  
      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }, []);

  return (
    <div ref={ref} className={`otros-finance-detail-component ${isVisible ? "visible" : ""}`}>
      <div className="title-otros-finance-detail-component">
        Más oportunidades{/* Oportunidades para este vehículo */}
      </div>
      <div className="opciones-otros-finance-detail-component">
        {opportunities?.map((item: any) => (
          <div
            className={`item-opciones-otros-finance-detail-component`}
            style={{
              backgroundImage:
                `URL(https://manager.hyundaicolombia.co/${item?.image?.url || item?.media?.url})`,
            }}
          >
            <div
              className={`mascara-item-opciones-otros-finance-detail-component`}
            >
              <div className="title-mascara-item-opciones-otros-finance-detail-component">
                {item?.title}
              </div>
              <a
                href={item?.url}
                className="btn-page-other-page-home-component"
              >
                {item?.button_text || item?.title}
              </a>
            </div>
          </div>
        ))}
        
      </div>
    </div>
  );
};

export default FinanzasOportunidadesComponent;
